import { createAsyncThunk } from '@reduxjs/toolkit';
import distributorApi from '../../../api/distributorApi';
import finishedGoodInventoryApi from '../../../api/finishedGoodInventoryApi';
import packingListApi from '../../../api/packingListApi';
import { downloadExcel } from '../../../services/xlsx';
import { download } from '../../../utils/files';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'packingList';

export const GetDistributors = createAsyncThunk(`${REDUCER_NAME}/getDistributors`, async (__, thunkAPI) => {
  const res = await distributorApi.get();

  if (res?.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue(null);
});

export const CreateDistributor = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createDistributor`,
  async (data, thunkAPI) => {
    const res = await distributorApi.post(data);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const GetFinishedGoodInventory = createAsyncThunk(
  `${REDUCER_NAME}/getFinishedGoodInventory`,
  async (__, thunkAPI) => {
    const res = await finishedGoodInventoryApi.get();

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const GetGroupedShippingBoxItems = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getGroupedShippingBoxItems`,
  async (id, thunkAPI) => {
    const res = await packingListApi.getGroupedShippingBoxItems(id);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const GetPackingLists = createAsyncThunk(`${REDUCER_NAME}/getPackingLists`, async (__, thunkAPI) => {
  const res = await packingListApi.get();

  if (res?.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue(null);
});

export const GetPackingListById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getPackingListById`,
  async (id, thunkAPI) => {
    const res = await packingListApi.getById(id);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const CreatePackingList = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createPackingList`,
  async (data, thunkAPI) => {
    const res = await packingListApi.create(data);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const UpdatePackingList = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updatePackingList`,
  async ({ id, data }, thunkAPI) => {
    const res = await packingListApi.update(id, data);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const ChangePackingListStatus = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/changePackingListStatus`,
  async ({ id, status }, thunkAPI) => {
    const res = await packingListApi.changeStatus(id, status);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const CreatePackingListInvoice = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/createPackingListInvoice`,
  async (id, thunkAPI) => {
    const res = await packingListApi.createInvoice(id);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const DeletePackingList = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/deletePackingList`,
  async (id, thunkAPI) => {
    const res = await packingListApi.delete(id);

    if (res?.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const DownloadPackingListCsv = createAsyncThunk<any, string>(
  'payroll/downloadPackingListCsv',
  async (id, thunkAPI) => {
    const res = await packingListApi.getCsv(id);

    if (res.status === 200) {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const fileName = res.headers['x-suggested-filename'];
      download(url, fileName);
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const DownloadPackingListXlsx = createAsyncThunk<any, string>(
  'payroll/downloadPackingListXlsx',
  async (id, thunkAPI) => {
    const res = await packingListApi.getXlsx(id);

    if (res.status === 200) {
      const { data, headers, filename } = res.data.data;
      downloadExcel(data, headers, { filename });
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const SplitPackingList = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/splitPackingList`,
  async (id, thunkAPI) => {
    const res = await packingListApi.split(id);

    if (res?.status === 200) {
      thunkAPI.dispatch(GetPackingLists());
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);
